<template>
    <div class="mwap_signup">
        <div class="signup_body">
            <div class="signup_title">上传视频</div>
            <div class="signup_up">
                <van-uploader v-model="fileList" accept="video/*" :after-read="afterRead" :before-delete="del" :max-size="10485760" @oversize="prompt_for_oversize">
                  <van-image v-if="fileList.length<=0" width="1.05rem" height="0.8rem" :src="require('assets/img/mwap/camera.png')"/>
                </van-uploader>
                <div v-if="fileList.length<=0" class="signup_notice">点击，上传视频（不大于10MB）</div>
            </div>
            <div class="signup_info">报名信息</div>
            <div class="signup_input">
                <van-field v-model="name" placeholder="联系人" />
                <van-field v-model="phone" type="tel" placeholder="联系电话" />
                <van-field v-model="title" type="textarea" placeholder="视频介绍" />
            </div>    
        </div>
        <div class="footer">
            <div class="mvbutton" @click="go">
                提交信息
            </div>
        </div>
        <van-overlay :show="show">
            <div class="wrapper">
                <van-loading size="24px" type="spinner" color="#1989fa" vertical>上传中...</van-loading>
            </div>          
        </van-overlay>
    </div>
</template>
<script>
    import './index.less'
    import { Uploader, Image, Field, Overlay, Loading } from 'vant';   
    import util from 'libs/utils';
    import axios from "axios";
    export default {
        name: "signup",
        data() {
            return {
                cgid: '',
                caid: '',
                show: false,
                mediaurl:'',
                id:'',
                fileList:[],
                title:'',
                name:'',
                phone:''
            }
        },
        components: {
            vanUploader:Uploader,
            vanImage:Image,
            vanField:Field,
            vanOverlay:Overlay,
            vanLoading:Loading
        },
        methods: {
            afterRead(file){
                this.show = true
                this.$api.system.upload(file).then(res=>{
                    if (res.status * 1 === 200) {
                        this.show = false;
                        this.$toast.success('上传成功！');
                        this.mediaurl = res.data.imgurl
                    }
                });
            },
            del(file){
                this.fileList = []
                this.mediaurl = ''
            },
            prompt_for_oversize: function(file) {
              this.dialog.alert({
                message: '文件大小应小于10M',
                confirmButtonText: "OK"
              }).then(() => {
                // on close
              });
            },
            go(){
                if(this.mediaurl==''||this.title==''||this.name==''||this.phone==''){
                    this.$toast.fail('请确认是否有未填项！');
                    return;
                } 
                this.$api.family.submitVoteInfo({title: this.title,mediaurl: this.mediaurl,name:this.name,phone:this.phone}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.$toast.success('提交成功！');
                        this.$router.replace({name:'exchange',params:{id:3}})
                    }
                });
            }
        },
        mounted() {
            this.caid = this.$route.params.caid;
            this.cgid = this.$route.params.cgid;
            this.id = this.$route.params.id;
        }
    }
</script>
